import styled from "styled-components";

const FormSectionHeader = styled.div`
    h2 {
        font-size: 1.2em;
    }
`;

export default FormSectionHeader;
